import React, {Component, Fragment} from 'react';
// helpers
import {getMatchDayMarketNameByCode} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetFootball.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import LockedAccaBet from "../../../components/lockedAccaBet";
import {getRoundedOdds} from "../helpers/matchdayHelper";
import {UNDER_OVER_25} from '../constants/marketTypes';

class LockedBetMatchday extends Component {

    _createEventDetails(eventDetails) {
        let noGoals = 'No goals';
        return (
            <div>
                <div className={`${style.eventDetailsLine} ${style.even}`}>
                    <div className={style.eventDetailsLineLeft}>{getText('HALF_TIME_RESULT', this.props.store)}</div>
                    <div className={style.eventDetailsLineRight}>{eventDetails.halfTimeResult}</div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (!this.props.isSettledBet)
            this.interval = setInterval(() => this.setState({time: Date.now()}), 1000);
    }

    componentWillUnmount() {
        if (!this.props.isSettledBet)
            clearInterval(this.interval);
    }

    render() {

        let eventDetails;
        let bet = this.props.betSelection.Bets[0];

        let homeTeam = getText("Matchday_" + bet.EventDetails.team1, this.props.store);
        let awayTeam = getText("Matchday_" + bet.EventDetails.team2, this.props.store);

        let voidStatus = bet.State === 'VOIDED';
        let title = `${homeTeam} ${getText('VS', this.props.store)} ${awayTeam}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);

        let betType = getMatchDayMarketNameByCode(marketInfo.marketCode);

        betType = getText(betType === UNDER_OVER_25.name ? 'UNDER_OVER_2_5' : betType, this.props.store, [homeTeam, awayTeam]);
        let odd = getRoundedOdds(this.props.betSelection.Bets, false);
        let name = '';
        if (marketInfo !== null) {
            name = isNaN(marketInfo.selection)
                ? getText(marketInfo.selection, this.props.store, [homeTeam, awayTeam])
                : marketInfo.selection;
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet.EventDetails)}</div>

                </div>
            );
            if (bet.EventDetails.fullTimeResult) {
                eventName.score = homeTeam + " " + bet.EventDetails.fullTimeResult.split('').join(' ') + " " + awayTeam;
                eventName.formated = (<div className={style.footballTitle}>
                    <div className={style.eventTime}>{`${eventName.dayMonthYear} `}{`${eventName.hoursMinutes} `}</div>
                    <p className={style.resultContainer}>
                        {`${homeTeam} `}{` ${bet.EventDetails.fullTimeResult.split('').join(' ')} `}{` ${awayTeam}`}</p>
                </div>);
            }
        }
        let lockedBet = this.props.betSelection.Bets.length === 1 ?
            (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                        betType={betType} odd={odd} eventName={eventName} leagueDay={bet.EventDetails.leagueDay}
                        names={[name]} isSettledBet={this.props.isSettledBet} voidStatus={voidStatus}/>) :
            (<LockedAccaBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                            betType={betType} odd={odd} names={[name]} isSettledBet={this.props.isSettledBet}
                            voidStatus={voidStatus}/>)

        return (<Fragment>{lockedBet}</Fragment>);
    }
}

export default LockedBetMatchday;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/lockedBetMatchday.js